import React, { Component } from "react";
import "./ViewPhotoSamplePopup.scss";
import correctPhoto from "../../../assets/PhotographSample/correctPhoto.jpg";
import hatCovered from "../../../assets/PhotographSample/hat-covered.svg";
import sunGlass from "../../../assets/PhotographSample/sunglass-covered.svg";
import shadow from "../../../assets/PhotographSample/shadow-covered.svg";
import BottomPanel from "../../BottomPanel/BottomPanel";
export interface IViewPhotoSampleMobileViewProps {
  setShowPopup: Function;
  showPopup: boolean;
  text?: any;
  children?: any;
}
const ViewPhotoSampleMobileViewProps = (props: IViewPhotoSampleMobileViewProps) => {
  const getMobileUIPopup = () => {
    return (
      <div className="mobile-view">
        <label className="mobile-view-text">Guide for Photo Upload</label>
        <div className="grid">
          <div className="box-1">
            <div className="profile-container">
              <img src={correctPhoto} alt="Profile" className="profile-image" />
              <div className="checkmark">✔</div>
            </div>
            <p className="success">
              Take a selfie facing the camera with a clear background.
            </p>
          </div>

          <div className="box-1">
            <img src={hatCovered} alt="hat covered" height={80} width={120} />
            <p className="error"> Don’t wear a hat.</p>
          </div>

          <div className="box-1">
            <img src={sunGlass} alt="sun glass" height={80} width={120} />
            <p className="error"> Don’t wear sunglasses. </p>
          </div>

          <div className="box-1">
            <img src={shadow} alt="Thick Stroke" height={80} width={120} />
            <p className="error"> Don’t click a dark and blurry photo.</p>
          </div>
        </div>
      </div>
    );
  };
  return (
    <BottomPanel
      customComponent={getMobileUIPopup}
      setShowSection={props?.setShowPopup}
    />
  );
};
export default ViewPhotoSampleMobileViewProps;
